module.exports = __webpack_public_path__ + "static/media/18ECA45.6909e966.jpg";